import cx from "classnames"
import * as styles from "./styles.module.scss"
import Odometer from "../Odometer"
import React, { useState, useEffect } from "react"
// import { getEnvironment } from "config/environment"
import logoBankrate from "images/logo-bankrate.svg"
import logoGoogle from "images/logo-google.svg"
import logoZillow from "images/logo-zillow.svg"
import { useInView } from "react-intersection-observer"

export interface ReviewRatingProps {
  count: number
  finalRating: number
  initialRating: number
  provider: Provider
}

type Provider = "google" | "zillow" | "bankrate"

const ReviewRating: React.FC<ReviewRatingProps> = ({
  count,
  provider,
  initialRating,
  finalRating,
}) => {
  const [ref, inView] = useInView({ threshold: 0 })

  const [rating, setRating] = useState(initialRating)
  const percentageRating = (finalRating / 5) * 100

  const logoSrc: React.FC = () => {
    switch (provider) {
      case "zillow":
        return logoZillow
      case "bankrate":
        return logoBankrate
      default:
      case "google":
        return logoGoogle
    }
  }

  // TODO: animate on load
  useEffect(() => {
    setRating(inView ? finalRating : initialRating)
  }, [inView])

  return (
    <div
      className={cx({
        [styles.reviewRating]: true,
        [styles[provider]]: provider,
      })}
    >
      {/* eslint-disable-next-line */}
      <a
        // href={`/${
        //   getEnvironment().apiNamespace
        // }/reviews/${provider}?utm_source=homepage`}
        rel="nofollow noopener noreferrer"
        target="_blank"
        className={styles.tapLink}
      />
      <div className={styles.rating}>
        <div
          className={cx({
            [styles.ratingNumber]: true,
            [styles.odometer]: true,
          })}
        >
          <Odometer value={rating} format={`(,ddd).d`} />
        </div>
        <div className={styles.starsWrapper}>
          <div
            className={cx({
              [styles.stars]: true,
              [styles.inView]: inView,
            })}
            ref={ref}
          >
            <div className={styles.starsGroupContainer}>
              <div
                className={cx({
                  [styles.starsGroup]: true,
                  [styles.empty]: true,
                })}
              >
                <div className={styles.starsContainer}>
                  <i
                    className={cx({
                      [styles.star]: true,
                      ["bsk-icon-star-fill"]: true,
                    })}
                  />
                  <i
                    className={cx({
                      [styles.star]: true,
                      ["bsk-icon-star-fill"]: true,
                    })}
                  />
                  <i
                    className={cx({
                      [styles.star]: true,
                      ["bsk-icon-star-fill"]: true,
                    })}
                  />
                  <i
                    className={cx({
                      [styles.star]: true,
                      ["bsk-icon-star-fill"]: true,
                    })}
                  />
                  <i
                    className={cx({
                      [styles.star]: true,
                      ["bsk-icon-star-fill"]: true,
                    })}
                  />
                </div>
              </div>
              <div
                className={cx({
                  [styles.starsGroup]: true,
                  [styles.full]: true,
                })}
                style={{ width: `${percentageRating}%` }}
              >
                <div className={styles.starsContainer}>
                  <i
                    className={cx({
                      [styles.star]: true,
                      ["bsk-icon-star-fill"]: true,
                    })}
                  />
                  <i
                    className={cx({
                      [styles.star]: true,
                      ["bsk-icon-star-fill"]: true,
                    })}
                  />
                  <i
                    className={cx({
                      [styles.star]: true,
                      ["bsk-icon-star-fill"]: true,
                    })}
                  />
                  <i
                    className={cx({
                      [styles.star]: true,
                      ["bsk-icon-star-fill"]: true,
                    })}
                  />
                  <i
                    className={cx({
                      [styles.star]: true,
                      ["bsk-icon-star-fill"]: true,
                    })}
                  />
                </div>
              </div>
            </div>
            <a
              className={styles.link}
              // href={`/${
              //   getEnvironment().apiNamespace
              // }/reviews/${provider}?utm_source=homepage`}
              rel="nofollow"
            >
              <span>{count}</span> reviews
            </a>
          </div>
        </div>
      </div>
      <div className={styles.logoContainer}>
        <img src={logoSrc()} className={styles.providerLogo} alt={provider} />
      </div>
    </div>
  )
}

export default ReviewRating
